export default "__VITE_ASSET__BR3TXu3v__"